module.exports = __webpack_public_path__ + "img/chapocut.ac0ec864.png";